import icons from "./icons.ts";
import images from "./images.ts";

export const navItems = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Industries", path: "/industries" },
  { label: "Blog", path: "/blog" },
  { label: "About Us", path: "/about" },
  { label: "Contact Us", path: "/contact" },
];

export const services = [
  {
    badge: "Service",
    icon: icons.services.applicationDevelopment,
    title: "Application Development",
    description:
      "Custom web and mobile solutions with modern architecture and flawless delivery.",
    link: "/ApplicationDevelopment",
    cardCta: "View Service",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.pages.applicationDevelopment,
  },
  {
    badge: "Service",
    icon: icons.services.aiDataOperations,
    title: "AI Data Operations",
    description:
      "High-quality data preparation and human-in-the-loop services for training and scaling AI models.",
    link: "/AIDataOperations",
    cardCta: "View Service",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.pages.aiDataOperations,
  },
  {
    badge: "Service",
    icon: icons.services.staffingService,
    title: "Staffing Service",
    description:
      "Skilled talent sourcing, workforce solutions and staffing support for growth teams.",
    link: "/StaffingService",
    cardCta: "View Service",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.pages.staffingService,
  },
  {
    badge: "Service",
    icon: icons.services.digitalMarketing,
    title: "Digital Marketing",
    description:
      "Performance-driven digital campaigns, SEO, social media and inbound strategy.",
    link: "/DigitalMarketing",
    cardCta: "View Service",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.pages.digitalMarketing,
  },
  {
    badge: "Service",
    icon: icons.services.rcmServices,
    title: "RCM Services",
    description:
      "Revenue cycle management solutions for healthcare providers and clinics.",
    link: "/RCMServices",
    cardCta: "View Service",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.pages.rcmServices,
  },
  {
    badge: "Service",
    icon: icons.services.talentContinuityManagement,
    title: "Talent Continuity Management",
    description:
      "It's about building careers and empowering futures. By aligning education, training, and deployment, we ensure success for candidates, clients, and the organization.",
    link: "/TalentContinuityManagement",
    cardCta: "View Service",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.pages.talentContinuityManagement,
  },
];

export const industries = [
  {
    badge: "Industry",
    icon: icons.industries.healthcare,
    title: "Healthcare",
    description:
      "Technology services for hospitals, clinics and medical enterprises.",
    link: "/industries",
    cardCta: "Explore",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.industries.healthcare,
  },
  {
    badge: "Industry",
    icon: icons.industries.finance,
    title: "Finance",
    description:
      "Financial technology, compliance support and data analytics for finance firms.",
    link: "/industries",
    cardCta: "Explore",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.industries.finance,
  },
  {
    badge: "Industry",
    icon: icons.industries.ecommerce,
    title: "E-commerce",
    description:
      "E-commerce solutions, retail optimization and customer engagement services.",
    link: "/industries",
    cardCta: "Explore",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.industries.ecommerce,
  },
  {
    badge: "Industry",
    icon: icons.industries.manufacturing,
    title: "Manufacturing",
    description:
      "Manufacturing digital transformation, quality control and operational support.",
    link: "/industries",
    cardCta: "Explore",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.industries.manufacturing,
  },
  {
    badge: "Industry",
    icon: icons.industries.education,
    title: "Education",
    description:
      "Learning systems, training platforms and education transformation services.",
    link: "/industries",
    cardCta: "Explore",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.industries.education,
  },
  {
    badge: "Industry",
    icon: icons.industries.banking,
    title: "Banking",
    description:
      "Banks perform several key functions that support both individuals and businesses.",
    link: "/industries",
    cardCta: "Explore",
    heroCta: "Contact Us",
    heroCtaLink: "/contact",
    image: images.industries.banking,
  },
];

const toFeatureCard = ({ icon, title, description, link, cardCta, image }) => ({
  icon,
  title,
  description,
  link,
  cta: cardCta,
  image,
});

const toHeroSlide = ({
  badge,
  title,
  description,
  heroCta,
  heroCtaLink,
  image,
}) => ({
  badge,
  title,
  subtitle: description,
  cta: heroCta,
  ctaLink: heroCtaLink,
  image,
});

const toHeroSection = ({
  title,
  description,
  heroCta,
  heroCtaLink,
  image,
}) => ({
  title,
  subtitle: description,
  cta: heroCta,
  ctaLink: heroCtaLink,
  image,
});

export const serviceFeatureCards = services.map(toFeatureCard);
export const industryFeatureCards = industries.map(toFeatureCard);
export const heroSlides = [...services, ...industries].map(toHeroSlide);

export const heroSections = {
  about: {
    title: "About Us",
    subtitle:
      "Welcome to Westlisoft, your trusted partner in the world of technology and innovation. We are a dynamic and forward-thinking company committed to delivering exceptional services in Digital Marketing, Application Development, Corporate Training, and Staffing. Delivering innovative technology solutions since inception",
    cta: "Contact Us",
    ctaLink: "/contact",
    image: images.pages.about,
  },
  aiDataOperations: {
    ...toHeroSection(services[1]),
  },
  applicationDevelopment: {
    ...toHeroSection(services[0]),
  },
  blog: {
    title: "Blog",
    subtitle:
      "Insights, news, and updates on technology, business, and digital transformation.",
    image: images.pages.blog,
  },
  contact: {
    title: "Contact Us",
    subtitle: "Get in touch with our team. We'd love to hear from you.",
    image: images.pages.contact,
  },
  digitalMarketing: {
    ...toHeroSection(services[3]),
  },
  disclaimer: {
    title: "Disclaimer",
    subtitle: "Important information about our website, content, and services.",
    image: images.pages.disclaimer,
  },
  faqs: {
    title: "FAQ's",
    subtitle: "Common questions and answers about our services and processes.",
    image: images.pages.faqs,
  },
  industries: {
    title: "Industries We Serve",
    subtitle: "Expert solutions for diverse business sectors",
    cta: "Contact Us",
    ctaLink: "/contact",
    image: images.pages.ourIndustries,
  },
  privacy: {
    title: "Privacy Policy",
    subtitle:
      "Our commitment to protecting your information and maintaining privacy.",
    image: images.pages.privacyPolicy,
  },
  rcmServices: {
    ...toHeroSection(services[4]),
  },
  services: {
    title: "Our Services",
    subtitle: "Comprehensive solutions tailored to your business needs",
    cta: "Contact Us",
    ctaLink: "/contact",
    image: images.pages.ourServices,
  },
  staffingService: {
    ...toHeroSection(services[2]),
  },
  talentContinuityManagement: {
    ...toHeroSection(services[5]),
  },
  terms: {
    title: "Terms & Conditions",
    subtitle: "The terms governing use of our website and services.",
    image: images.pages.termsConditions,
  },
};

export const clientLogos = [
  { name: "TATA", image: images.clientLogos.tata },
  { name: "TCS", image: images.clientLogos.tcs },
  { name: "Amazon", image: images.clientLogos.amazon },
  { name: "Flipkart", image: images.clientLogos.flipkart },
  { name: "LogiTech", image: images.clientLogos.logitech },
  { name: "FINT", image: images.clientLogos.fint },
  { name: "Forasoft", image: images.clientLogos.forasoft },
  { name: "L&T", image: images.clientLogos.landT },
];

export const testimonials = [
  {
    name: "MS. KALPANA ANNU",
    title: "Director - Staff Augmentation (Foraysoft Pvt. Ltd)",
    content:
      "I can confidently say that Westlisoft Technologies is the epitome of a consulting firm that consistently exceeds expectations. Their commitment to our success was evident in every interaction, and we are now reaping the benefits of their expertise. We highly recommend Westlisoft to any organization seeking top-tier consulting services",
    rating: 5,
    avatar: images.people.kalpana,
  },
  {
    name: "KRISHNA CHAITANYA",
    title: "AI / ML Specialist",
    content:
      "Westlisoft Technologies has set a benchmark for what corporate training support should be. We highly recommend their services to any organization seeking the best in corporate training. They truly embody the meaning of 'excellence in support.' Thank you, Westlisoft, for your outstanding commitment to our success.",
    rating: 5,
    avatar: images.people.krishnaChaitanya,
  },
  {
    name: "Sneha Das",
    title: "HR Lead, Corporate Training",
    content:
      "The training program and staffing service helped our team grow capabilities fast. The trainers were knowledgeable and engaging, and the staffing support was seamless. We highly recommend Westlisoft for corporate training and staffing needs. Their expertise and support made a significant impact on our team's development and success.",
    rating: 4,
    avatar: images.people.smileyBusinesswoman,
  },
];

export const footerLinks = {
  Company: [
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Industries", path: "/industries" },
    { label: "Blog", path: "/blog" },
  ],
  Resources: [
    { label: "FAQ", path: "/faqs" },
    { label: "Privacy Policy", path: "/privacy" },
    { label: "Terms & Conditions", path: "/terms" },
    { label: "Disclaimer", path: "/disclaimer" },
  ],
  Contact: [
    { label: "Phone", icon: icons.contact.phone, href: "tel:+918977937065" },
    {
      label: "Email",
      icon: icons.contact.email,
      href: "mailto:info@westlisoft.com",
    },
    {
      label: "WhatsApp",
      icon: icons.contact.whatsapp,
      href: "https://wa.me/918977937065",
    },
  ],
};

export const socialLinks = [
  {
    label: "Facebook",
    icon: icons.social.facebook,
    compactIcon: icons.social.facebookF,
    href: "https://www.facebook.com/people/Westlisoft-Technologies/61551804149306/",
  },
  {
    label: "X",
    icon: icons.social.twitter,
    compactIcon: icons.social.twitter,
    href: "https://x.com/westlisoft",
  },
  {
    label: "LinkedIn",
    icon: icons.social.linkedIn,
    compactIcon: icons.social.linkedInIn,
    href: "https://www.linkedin.com/company/westlisoft-technologies/mycompany/",
  },
  {
    label: "Instagram",
    icon: icons.social.instagram,
    compactIcon: icons.social.instagram,
    href: "https://www.instagram.com/westlisoft/",
  },
  {
    label: "YouTube",
    icon: icons.social.youtube,
    compactIcon: icons.social.youtube,
    href: "https://www.youtube.com/@WestlisoftTechnologies",
  },
];

export const contactInfo = [
  {
    icon: icons.contact.location,
    label: "Head Office",
    value: "DSL abacus IT park, Uppal, Hyderabad",
    href: "https://www.google.co.in/maps/place/DSL+Abacus+IT+Park,+IDA+Uppal,+Uppal,+Hyderabad,+Telangana+500039/@17.4042758,78.537396,14.5z/data=!4m6!3m5!1s0x3bcb993b079ca3ad:0x1c7a0f123c227041!8m2!3d17.399687!4d78.5513501!16s%2Fg%2F11xt2yhd8k?entry=ttu&g_ep=EgoyMDI2MDYyMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    label: "Other Branches:",
  },
  {
    icon: icons.contact.location,
    label: "Telangana",
    value: "Manjeera Trinity Corporate, KBHP, Hyderabad",
    href: "https://www.google.co.in/maps/place/Manjeera+Trinity+Corporate/@17.4892289,78.3875968,16.75z/data=!4m10!1m2!2m1!1sManjeera+Trinity+Corporate!3m6!1s0x3bcb918dab342375:0x180a04af0c47f594!8m2!3d17.4893763!4d78.3926563!15sChpNYW5qZWVyYSBUcmluaXR5IENvcnBvcmF0ZVocIhptYW5qZWVyYSB0cmluaXR5IGNvcnBvcmF0ZZIBD2J1c2luZXNzX2NlbnRlcuABAA!16s%2Fg%2F11gbx8t856?entry=ttu&g_ep=EgoyMDI2MDYyMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    icon: icons.contact.location,
    label: "Andhrapradesh",
    value: "4th Town Junction, Vizag",
    href: "https://www.google.co.in/maps/place/4th+Town+Police+Station/@17.738066,83.3026532,17z/data=!3m1!4b1!4m6!3m5!1s0x3a394331f3900001:0xce3357499afab38e!8m2!3d17.7380609!4d83.3052281!16s%2Fg%2F1td6wjv6?entry=ttu&g_ep=EgoyMDI2MDYyMi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    icon: icons.contact.phone,
    label: "Phone",
    value: "+91 8977-937 065",
    href: "tel:+918977937065",
  },
  {
    icon: icons.contact.email,
    label: "Email",
    value: "info@westlisoft.com",
    href: "mailto:info@westlisoft.com",
  },
  {
    icon: icons.contact.whatsapp,
    label: "WhatsApp",
    value: "+91 8977-937 065",
    href: "https://wa.me/918977937065",
  },
];

export const featureCards = {
  services: serviceFeatureCards,
  industries: industryFeatureCards,
};
